<template>
  <div class="text-center">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="blue" dark v-bind="attrs" v-on="on">
          Menu
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in availableItems"
          :key="index"
          @click="handleRoute(item.route)"
        >
          <v-list-item-title :v-if="item.hasAccess">{{
            item.title
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  data: () => ({
    userClass: null,
  }),

  methods: {
    handleRoute(path) {
      if (path != "logout") {
        if (this.$route.path !== path) {
          this.$router.push(path).catch((error) => {
            if (error.name != "NavigationDuplicated") {
              throw error;
            }
          });
        }
      } else {
        this.localStorage.token = "";
        this.localStorage.accessLevel = "";
        this.localStorage.endDate = "";
        this.$router.push("/");
      }
    },
  },

  computed: {
    availableItems() {
      let userClass = this.localStorage.accessLevel;
      if (userClass == "user") {
        return [
          { title: "Dashboard", route: "dashboard" },
          { title: "Log Out", route: "logout" },
        ];
      } else if (userClass == "admin") {
        return [
          { title: "Administration", route: "admin" },
          { title: "Dashboard", route: "dashboard" },
          { title: "Log Out", route: "logout" },
        ];
      } else {
        return [
          { title: "Login", route: "/" },
          { title: "Register", route: "register" },
        ];
      }
    },
  },
};
</script>
